var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"dashboard"}},[_c('b-header'),_c('grey-banner'),_c('settings-sidebar'),_c('aside',{attrs:{"id":"settings-right"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }